"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.containsStringMatcherContext = void 0;
var lang_1 = require("../../utils/lang");
function containsStringMatcherContext(ruleAttr) {
    return function containsStringMatcher(runtimeAttr) {
        var contains = ruleAttr.some(function (e) { return (0, lang_1.isString)(runtimeAttr) && runtimeAttr.indexOf(e) > -1; });
        return contains;
    };
}
exports.containsStringMatcherContext = containsStringMatcherContext;
